import { lazy } from 'react';
import ExperimentHeadingText from './variants/OpenBankingH1Test/ExperimentHeadingText';
import ObOptInJourney1 from './variants/OpenBankingAcceptRegionTest/ObOptInJourneyCard.jsx';

/**
 * Container dictionary of active Adobe form based composer experiments
 *
 * @example
 *
 * const container = {
 *   'quotations-batchrequote-mbox': {
 *       B: lazy(() => import('./variants/Sample/Sample')),
 *       C: EagerSample
 *   }
 * // where EagerSample is an imported React.FunctionComponent
 *
 * @type {{string: Object.<string, ReactNode>}}
 */
const container = {
    'quotations-ob-landing-heading-mbox': {
        B: ExperimentHeadingText
    },
    'quotations-ob-landing-factorial-mbox': {
        B: lazy(() => import('./variants/OpenBankingFactorialTest/VariantB')),
        C: lazy(() => import('./variants/OpenBankingFactorialTest/VariantC')),
        D: lazy(() => import('./variants/OpenBankingFactorialTest/VariantD'))
    },
    'quotations-ob-accept-region-opt-in-mbox': {
        B: ObOptInJourney1
    }
};

export default container;
